export const RouterName = {
  auth: {
    login: "/auth/login",
    signup: "",
    forgotPassword: "/auth/forgot-password",
    resetPassword: "/auth/reset-password/:token",
    maintenance: "/auth/maintenance",
  },
  admins: {
    admins: "/admins",
    privileges: "/privileges",
  },

  settings: {
    settings: "/settings",
    settings_details: "/settings/details",
  },

  legal_information: {
    legal_information: "/legal_information",
  },

  features: {
    features: "/features",
  },

  fleet: {
    fleet: "/fleet",
  },

  contact: {
    contact: "/contact",
  },

  stats: {
    stats: "/stats",
  },

  testimonials: {
    testimonials: "/testimonials",
  },

  admins_logs: {
    admins_logs: "/admins_logs",
  },
};
